import { useState } from 'react';
import useContactStore from '@/stores/ContactStore';
import { ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

import { cn } from '@/lib/utils';
import { sendCopilotFeedback } from '@/hooks/contact';
import { Button } from '@/components/ui/button';

const CopilotFeedbackButtons = ({ message, addMessage }) => {
  const [sendingMessageId, setSendingMessageId] = useState(null);

  // Get store values
  const { updateCopilotMessageFeedback } = useContactStore(
    useShallow((state) => ({
      updateCopilotMessageFeedback: state.updateCopilotMessageFeedback,
    }))
  );

  const handleFeedback = async (message, isUseful) => {
    try {
      const suggestion = isUseful ? 'Good' : 'Bad';
      await sendCopilotFeedback(
        message._id,
        message.response_id,
        isUseful,
        suggestion
      );
      updateCopilotMessageFeedback(message._id, message.response_id, isUseful);
      toast.success('Thank you for your feedback!');
    } catch (error) {
      toast.error('Failed to send feedback. Please try again.');
    }
  };

  const handleSendMessage = async (message) => {
    try {
      setSendingMessageId(message._id);
      await addMessage(message.text, 'text');
    } catch (error) {
      console.error('Failed to send message. Please try again.');
    } finally {
      setSendingMessageId(null);
    }
  };

  return (
    <div className='flex items-start justify-start gap-1'>
      <Button
        size='xs'
        variant='ghost'
        className='h-8 w-8 shrink-0 self-start rounded-lg p-0 hover:bg-secondary'
        onClick={() => handleFeedback(message, true)}
        title='Upvote'
      >
        <ThumbsUpIcon
          className={cn(
            'h-4 w-4',
            message.feedback?.is_useful === true
              ? 'text-primary'
              : 'text-muted-foreground'
          )}
        />
      </Button>
      <Button
        size='xs'
        variant='ghost'
        className='h-8 w-8 shrink-0 rounded-lg p-0 hover:bg-secondary'
        onClick={() => handleFeedback(message, false)}
        title='Downvote'
      >
        <ThumbsDownIcon
          className={cn(
            'h-4 w-4',
            message.feedback?.is_useful === false
              ? 'text-primary'
              : 'text-muted-foreground'
          )}
        />
      </Button>
      {/* Disable sending message for now */}
      {/* <Button
        size='xs'
        className='shrink-0 rounded-lg px-4 text-xs'
        onClick={() => handleSendMessage(message)}
        disabled={sendingMessageId !== null}
      >
        Send Message
      </Button> */}
    </div>
  );
};

export default CopilotFeedbackButtons;
